// Suppress console warnings about unsupported PerformanceObserver entryTypes (longtask)
// This is typically caused by browser extensions trying to use unsupported APIs
(function() {
  const originalWarn = console.warn;
  console.warn = function(...args) {
    const message = args.join(' ');
    // Filter out longtask warnings from browser extensions
    if (message.includes('Ignoring unsupported entryTypes: longtask') || 
        message.includes('unsupported entryTypes: longtask')) {
      return; // Suppress this warning
    }
    // Call original warn for all other messages
    originalWarn.apply(console, args);
  };
})();

// Swym Input Override - Inject styles after Swym loads
function injectSwymInputStyles() {
  const style = document.createElement('style');
  style.textContent = `
    .swym-ui-component .swym-htc-add-wishlist-modal-shopper .swym-modal-content .swym-input, 
    .swym-ui-component .swym-input,
    .swym-list-name-input.swym-input,
    .swym-htc-add-wishlist-modal-shopper .swym-list-name-input.swym-input,
    div.swym-modal.swym-htc-add-wishlist-modal-shopper .swym-list-name-input.swym-input,
    .swym-modal .swym-list-name-input.swym-input,
    input.swym-list-name-input.swym-input {
      background: #121212 !important;
      background-color: #121212 !important;
    }
  `;
  document.head.appendChild(style);
}

// Try to inject styles multiple times to catch Swym when it loads
setTimeout(injectSwymInputStyles, 1000);
setTimeout(injectSwymInputStyles, 3000);
setTimeout(injectSwymInputStyles, 5000);

// Also inject when Swym modal opens
document.addEventListener('click', function(e) {
  if (e.target.closest('.swym-wishlist-button') || e.target.closest('.swym-add-to-wishlist')) {
    setTimeout(injectSwymInputStyles, 500);
  }
});

$(window).on("load", function(){
  
  // Load images in collections product grid image container on swatch hover
  setTimeout(function(){
    $(".grid-product .pl-swatches-collection .pl-swatches-collection__swatch-wrapper").on("mouseenter", function(){
      let firstImage = $(this).closest(".grid__item-image-wrapper").find(".grid__image-ratio");
      let secondaryImage = $(this).closest(".grid__item-image-wrapper").find(".grid-product__secondary-image");
      let swatchImage = $(this).find("img").attr("src").replace("_40x40@3x", "");

      if(secondaryImage.length > 0 ){
        secondaryImage.find("img").attr("srcset", swatchImage);
      } else {
        firstImage.find("img").attr("srcset", swatchImage);
      }

    });
    $(".grid-product .pl-swatches-collection .pl-swatches-collection__swatch-wrapper").on("mouseleave", function(){
      let firstImage = $(this).closest(".grid__item-image-wrapper").find(".grid__image-ratio");
      let secondaryImage = $(this).closest(".grid__item-image-wrapper").find(".grid-product__secondary-image");
      let firstImageSrc = firstImage.find("img").attr("src");
      let secondaryImageSrc = secondaryImage.find("img").attr("src");
      if(secondaryImage.length > 0 ){
        secondaryImage.find("img").attr("srcset", secondaryImageSrc);
      } else {
        firstImage.find("img").attr("srcset", firstImageSrc);
      }
    });

    // Product swatches hover functionality for collection grid
    // Initialize hover handlers for existing products
    $(".grid-product__variant-swatch").each(function(){
      const $swatch = $(this);
      const $productElement = $swatch.closest(".grid-product");
      const $imageWrapper = $productElement.find("[data-product-image-wrapper]");
      const $productContent = $productElement.find(".grid-product__content");
      
      if ($imageWrapper.length === 0) return;
      
      // Store original image sources if not already stored
      if (!$imageWrapper.data("original-images-stored")) {
        const $firstImage = $imageWrapper.find(".grid__image-ratio img");
        const $imageWrap = $imageWrapper.find(".image-wrap img");
        const $secondImage = $imageWrapper.find(".grid-product__secondary-image");
        
        if ($firstImage.length > 0) {
          $imageWrapper.data("original-first-src", $firstImage.attr("src"));
          $imageWrapper.data("original-first-srcset", $firstImage.attr("srcset"));
        }
        if ($imageWrap.length > 0) {
          $imageWrapper.data("original-wrap-src", $imageWrap.attr("src"));
          $imageWrapper.data("original-wrap-srcset", $imageWrap.attr("srcset"));
        }
        if ($secondImage.length > 0) {
          $imageWrapper.data("has-secondary-image", true);
        }
        $imageWrapper.data("original-images-stored", true);
      }
      
      // Remove existing handlers to avoid duplicates
      $swatch.off("mouseenter mouseleave");
      
      // Add hover handlers with event propagation control
      $swatch.on("mouseenter", function(e) {
        e.stopPropagation(); // Prevent card hover from triggering
        
        const variantImage = $(this).data("variant-image");
        if (!variantImage) return;
        
        const $firstImage = $imageWrapper.find(".grid__image-ratio img");
        const $secondImage = $imageWrapper.find(".grid-product__secondary-image");
        const $imageWrap = $imageWrapper.find(".image-wrap img");
        
        // Hide secondary image when hovering over swatches
        if ($secondImage.length > 0) {
          $secondImage.css("opacity", "0");
          $productContent.addClass("variant-swatch-hovering");
        }
        
        // Replace main image with variant image
        if ($firstImage.length > 0) {
          $firstImage.attr("src", variantImage);
          $firstImage.attr("srcset", variantImage);
        } else if ($imageWrap.length > 0) {
          $imageWrap.attr("src", variantImage);
          $imageWrap.attr("srcset", variantImage);
        }
      });
      
      $swatch.on("mouseleave", function(e) {
        e.stopPropagation(); // Prevent card hover from triggering
        
        const $firstImage = $imageWrapper.find(".grid__image-ratio img");
        const $secondImage = $imageWrapper.find(".grid-product__secondary-image");
        const $imageWrap = $imageWrapper.find(".image-wrap img");
        
        // Check if we're still hovering over any swatch in this product
        const $swatchesContainer = $productElement.find(".grid-product__variant-swatches");
        const isHoveringSwatches = $swatchesContainer.is(":hover") || $swatchesContainer.find(":hover").length > 0;
        
        if (!isHoveringSwatches) {
          // Restore original image
          const originalFirstSrc = $imageWrapper.data("original-first-src");
          const originalFirstSrcset = $imageWrapper.data("original-first-srcset");
          const originalWrapSrc = $imageWrapper.data("original-wrap-src");
          const originalWrapSrcset = $imageWrapper.data("original-wrap-srcset");
          
          if ($firstImage.length > 0 && originalFirstSrc) {
            $firstImage.attr("src", originalFirstSrc);
            $firstImage.attr("srcset", originalFirstSrcset || originalFirstSrc);
          } else if ($imageWrap.length > 0 && originalWrapSrc) {
            $imageWrap.attr("src", originalWrapSrc);
            $imageWrap.attr("srcset", originalWrapSrcset || originalWrapSrc);
          }
          
          // Restore secondary image visibility
          if ($secondImage.length > 0) {
            $secondImage.css("opacity", "");
            $productContent.removeClass("variant-swatch-hovering");
          }
        }
      });
    });
    
    // Initialize image loading handlers for existing variant swatch images
    initializeVariantSwatchImages($(".grid-product__variant-swatch-image"));
    
    // Preload variant images for existing products
    $(".grid-product__variant-swatches").each(function() {
      const $swatchesContainer = $(this);
      const $swatches = $swatchesContainer.find(".grid-product__variant-swatch");
      const variants = [];
      
      // Extract variant image URLs from data attributes
      $swatches.each(function() {
        const variantImage400 = $(this).data("variant-image");
        if (variantImage400) {
          // Extract base URL and create variant object for preloading
          const baseUrl = variantImage400.replace(/_400x400\.(jpg|jpeg|png|webp)/i, '');
          variants.push({
            featured_image: baseUrl,
            image: baseUrl
          });
        }
      });
      
      if (variants.length > 0) {
        preloadVariantImages($swatchesContainer, variants);
      }
    });
  }, 2000);

  //$('.page-starforged .feature-row-wrapper').attr("data-aos", "zoom-in");
  /* Image text group */
    $( "#shopify-section-template--15005489660007__1f7178f8-565f-47f4-99cf-5926fc2d4925, #shopify-section-template--15005489660007__882fad16-7547-4b71-b229-7c12113c73f2, #shopify-section-template--15005489660007__f14ae593-196f-4b5d-a8dd-ba9bf4787626, #shopify-section-template--15005489660007__99629106-dfd3-4a0c-927f-8cc63014f417" ).wrapAll( "<div class='sf-bg-2 parallax' />");
  /* Typewriter group 
    $(".index-section--sf-typewriter, #shopify-section-template--16073735078080__8c6815c1-db52-4711-98f9-7bc86ce3caf7").wrapAll( "<div class='sf-bg-gradient' />");
  */
  
  let sfLogo = $('.page-starforged .image__secondary');
  $(window).on("scroll", function(){
    var distance = $('div').offset().top,
    $window = $(window);

        if ( $window.scrollTop() >= distance ) {
            // Your div has reached the top
        }

    let movement = 50 - (window.scrollY / 25);
    sfLogo.css("top", movement + "%");
    sfLogo.css("opacity", 1 - (window.scrollY / 200) );
  });

  //New to DF wrap
  $( "#shopify-section-template--15005488873575__4e514938-5639-472d-be2b-67ee40dff7fe, #shopify-section-template--15005488873575__db22ef76-1b0d-45f3-be6d-a79a53a6e650, #shopify-section-template--15005488873575__6dcdc856-a78c-4102-aa52-30eae8c6addc, #shopify-section-template--15005488873575__7558e1f5-bd1f-4e7e-a906-6fc3804201c6, #shopify-section-template--15005488873575__e3b7011a-f04e-4fd1-81f2-6d3b5c43de53, #shopify-section-template--15005488873575__19a2ef23-d01b-40ee-83ce-6535e5e53f98" ).wrapAll( "<div class='ntdf-terrain' />");
  setTimeout(function(){
    $('.ntdf-terrain').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }, 2000);
});

window.addEventListener("hashchange", function () {
    window.scrollTo(window.scrollX, window.scrollY - 100);
});

/* Load more functionality for collection grid */
var products_on_page = $('.products-on-page');
var next_url = $('.pagination .next a').attr('href');

var loadMoreBtn = $('.load-more-products');
var loadMoreSpinner = $('.load-more-spinner');

function loadMoreProducts(){
  $.ajax({
    url: next_url,
    type: "GET",
    dataType: "html",
    beforeSend: function(){
      loadMoreBtn.hide();
      loadMoreSpinner.show();
    }
  }).done(function(next_page){
    console.log('[LoadMore] Loaded next page from:', next_url);
    loadMoreSpinner.hide();
    var new_products = $(next_page).find('.products-on-page');
    var new_url = $(next_page).find('.pagination .next a').attr('href');

    console.log('[LoadMore] Found', new_products.find('.grid-product').length, 'products on next page');
    console.log('[LoadMore] New next_url:', new_url);

    if(new_url){
      loadMoreBtn.show();
    }
    next_url = new_url;
    products_on_page.append(new_products.html());
    $('.image-element').css('opacity', '1');
    
    console.log('[LoadMore] Appended products, now filtering...');
    
    // Move products with hide_from_collection_grid tag to the end
    const movedCount = moveHiddenProductsToEnd();
    
    console.log('[LoadMore] Moved', movedCount, 'products to end after load more');
  });
}

$(document).ready(function(){
    // Update next_url if not already set
    if(next_url == undefined){
      next_url = $('.pagination .next a').attr('href');
    }
    
    if(next_url == undefined){
      loadMoreBtn.hide();
      $('.browse-by-page').hide();
    }

  var shadowHost = document.querySelector('#shadow-wrapper'); // or whatever top wrapper
  var shadowRoot = shadowHost.shadowRoot;
  
  var style = document.createElement('style');
  style.textContent = `
    @media (max-width: 768px) {#my-chatbot > div {
      bottom: 63px !important;
    }
    }
  `;
  shadowRoot.appendChild(style);
});

setInterval(function(){
    $('.tmenu_item_level_1').on("click", function(){
        $('.tmenu_item_level_1').attr('id', '');
        $(this).attr('id', 'tmenu_new_active');
      });
}, 500);

$(window).on('load', function(){
  console.log('[WindowLoad] Window loaded, starting checks');
  
  if(localStorage.getItem("Open Cart") == "true"){
    $('a[aria-controls="CartDrawer"]')[0].click();
    localStorage.setItem("Open Cart", false);
  }

  if($(window).width() < 769){
    setTimeout(function(){
      $('.collection-filter__item.collection-filter__item--sort').appendTo('.grid__item.medium-up--one-fifth.grid__item--sidebar');
    }, 500);
  }

  // Update next_url on window load
  if (!next_url) {
    next_url = $('.pagination .next a').attr('href');
    console.log('[WindowLoad] Set initial next_url:', next_url);
  }
  
  const initialCount = $('.products-on-page .grid-product').length;
  console.log('[WindowLoad] Initial product count on window load:', initialCount);
  
  // Filter products with hide_from_collection_grid tag on page load
  // Add delays to catch cloud search products that load asynchronously
  setTimeout(function() {
    console.log('[WindowLoad] Check 1 (2s delay) - Starting...');
    if (!next_url) {
      next_url = $('.pagination .next a').attr('href');
      console.log('[WindowLoad] Check 1 - Updated next_url:', next_url);
    }
    const currentCount = $('.products-on-page .grid-product').length;
    console.log('[WindowLoad] Check 1 - Current product count:', currentCount);
    const movedCount = moveHiddenProductsToEnd();
    console.log('[WindowLoad] Check 1 - Moved', movedCount, 'products to end');
  }, 2000);
  
  setTimeout(function() {
    console.log('[WindowLoad] Check 2 (4s delay) - Starting...');
    if (!next_url) {
      next_url = $('.pagination .next a').attr('href');
      console.log('[WindowLoad] Check 2 - Updated next_url:', next_url);
    }
    const currentCount = $('.products-on-page .grid-product').length;
    console.log('[WindowLoad] Check 2 - Current product count:', currentCount);
    const movedCount = moveHiddenProductsToEnd();
    console.log('[WindowLoad] Check 2 - Moved', movedCount, 'products to end');
  }, 4000);
  
  setTimeout(function() {
    console.log('[WindowLoad] Check 3 (6s delay) - Starting...');
    if (!next_url) {
      next_url = $('.pagination .next a').attr('href');
      console.log('[WindowLoad] Check 3 - Updated next_url:', next_url);
    }
    const currentCount = $('.products-on-page .grid-product').length;
    console.log('[WindowLoad] Check 3 - Current product count:', currentCount);
    const movedCount = moveHiddenProductsToEnd();
    console.log('[WindowLoad] Check 3 - Moved', movedCount, 'products to end');
  }, 6000);
});

  // Custom AJAX Cart Handler for Related Products
  window.addToCartCustom = function(button) {
    var $button = $(button);
    var productId = $button.data('product-id');
    var productTitle = $button.data('product-title');
    var productPrice = $button.data('product-price');
    var quantity = $button.data('quantity') || 1;
    var originalText = $button.text();
    
    // Show loading state
    $button.text('Adding...').prop('disabled', true);
    
    // Prepare cart data
    var cartData = {
      id: productId,
      quantity: parseInt(quantity)
    };
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: cartData,
      dataType: 'json',
      success: function(response) {
        // Show success state briefly
        $button.text('Added!');
        
        // Update cart bubble
        $('.cart-link__bubble').addClass('cart-link__bubble--visible');
        
        // Set localStorage to open cart after refresh
        localStorage.setItem("Open Cart", "true");
        
        // Reset button after delay
        setTimeout(function() {
          $button.text(originalText).prop('disabled', false);
        }, 1500);
        
        // Force page refresh to update cart contents
        setTimeout(function() {
          location.reload();
        }, 2000);
      },
      error: function(xhr, status, error) {
        // Reset button on error
        $button.text(originalText).prop('disabled', false);
        
        // Show error message
        var errorMessage = "Error adding to cart";
        if (xhr.responseJSON && xhr.responseJSON.message) {
          errorMessage = xhr.responseJSON.message;
        } else if (xhr.responseJSON && xhr.responseJSON.description) {
          errorMessage = xhr.responseJSON.description;
        }
        
        alert(errorMessage);
      }
    });
  };

/* Not currently working 
  function refreshCart(){
    $.ajax({
      url: window.location.href,
      type: "GET",
      dataType: "html",
      beforeSend: function(){
      }
    }).done(function(next_page){
      var new_cart = $(next_page).find('#CartDrawer');
      $('#CartDrawer').replaceWith(new_cart);
    });
  } */

/* Light/Dark Mode */
$(document).ready(function(){

  $('.tmenu_item_level_0.tmenu_item_has_child > a').on('click', function(e) {
    e.preventDefault(); // Prevent following "#" href
  
    const $parent = $(this).parent(); // li.tmenu_item_level_0
  
    if ($parent.hasClass('tmenu_item_active')) {
      $parent.removeClass('tmenu_item_active');
    } else {
      $('.tmenu_item_level_0.tmenu_item_has_child').removeClass('tmenu_item_active');
      $parent.addClass('tmenu_item_active');
    }
  });

  $('.site-nav.medium-up--hide').on('click', function(){
    $('.mm-2025-overlay').fadeIn();
    $('.menu.menu-level-0').addClass('active');
  });

  $('.mm-2025 .menu li.has-children').on('click', function(){
    var goTo = $(this).data('linkto');
    $('.mm-2025 .menu[data-link="'+goTo+'"]').addClass('active');
  });

  $('.mm-2025 .menu .back-button').on('click', function(){
    $(this).parent().removeClass('active');
  });

  $('.mm-2025 .menu .close, .mm-2025-overlay').on('click', function(){
    $('.mm-2025-overlay').fadeOut();
    $('.mm-2025 .menu').removeClass('active');
  })


  if (localStorage.getItem('lightMode') == null){
    localStorage.setItem('lightMode', false);
  }

  if (localStorage.getItem('lightMode') == "true") {
    $('.light-dark-mode').addClass('dark-mode');
    $('.light-dark-mode .switch').text('Dark Mode');
    $('body, .shopify-section, .shopify-section .page-width').addClass('light-mode');
    $('body').append('<link rel="stylesheet" type="text/css" href="https://cdn.shopify.com/s/files/1/0644/2359/files/light-mode.css">');
  } else {
    $('link[rel=stylesheet][href*="https://cdn.shopify.com/s/files/1/0644/2359/files/light-mode.css"]').remove();
  }
  
  $('.light-dark-mode').on('click', function(){
    $('body, .shopify-section, .shopify-section .page-width').toggleClass('light-mode');
    localStorage.setItem('lightMode', $('body').hasClass('light-mode'));

    if (localStorage.getItem('lightMode') == "true") {
      $('.light-dark-mode').addClass('dark-mode');
      $('.light-dark-mode .switch').text('Dark Mode');
      $('body').append('<link rel="stylesheet" type="text/css" href="https://cdn.shopify.com/s/files/1/0644/2359/files/light-mode.css">')
    } else {
      $('.light-dark-mode').removeClass('dark-mode');
      $('.light-dark-mode .switch').text('Light Mode');
      $('link[rel=stylesheet][href*="https://cdn.shopify.com/s/files/1/0644/2359/files/light-mode.css"]').remove();
    }
      
  });

  document.addEventListener('lookfor-add-to-cart', function(event) {
  console.log('[lookfor-add-to-cart] Event caught:', event.detail);

  // Show loading spinner (optional)
  let cartDrawer = document.querySelector('#CartDrawer');
  let loadingSpinner;

  // Check if cart drawer exists, if not create it
  if (!cartDrawer) {
    cartDrawer = injectCartDrawer(); // Dynamically inject the cart drawer
    console.log('[Cart Drawer Injected]');
  }

  loadingSpinner = cartDrawer.querySelector('.loading-spinner');
  if (loadingSpinner) {
    loadingSpinner.style.display = 'block'; // Show spinner
  }

  // Send AJAX request to fetch the updated cart data (cart.js)
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch cart data. Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('[Cart data fetched]', data);

      // Hide the loading spinner if it exists
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none'; // Hide spinner
      }

      // Update the cart content
      updateCartDrawerContent(data);

      // Show the cart bubble when items are added
      toggleCartBubble(data);
    })
    .catch(error => {
      console.error('[Error fetching cart data]', error);
      if (error instanceof Error) {
        console.error('Error message:', error.message);
      }

      // Hide the loading spinner if it exists
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none'; // Hide spinner
      }

      // Optionally, show an error message to the user
      alert('Sorry, there was an issue updating your cart. Please try again.');
    });
});

/* Product Description "See More" Functionality - Updated */
$(document).ready(function() {
  function initializeProductDescriptionToggle() {
    $('.product-description-container').each(function() {
      const $container = $(this);
      const $fullText = $container.find('.product-description-text');
      const $truncatedText = $container.find('.product-description-truncated');
      const $toggle = $container.find('.product-description-toggle');
      const $toggleText = $toggle.find('.toggle-text');
      
      // Check if content needs truncation (more than 500 characters)
      const fullTextContent = $fullText.text().trim();
      const truncatedContent = $truncatedText.text().trim();
      
      if (fullTextContent.length > 400) {
        // Show truncated version initially
        $fullText.hide();
        $truncatedText.show();
        $toggle.show();
        $toggle.attr('aria-expanded', 'false');
        $toggleText.text('see more');
        
        // Handle toggle click
        $toggle.off('click').on('click', function() {
          const isExpanded = $toggle.attr('aria-expanded') === 'true';
          
          if (!isExpanded) {
            // Expand - show full text
            $truncatedText.hide();
            $fullText.show();
            $toggle.attr('aria-expanded', 'true');
            $toggleText.text('see less');
          } else {
            // Collapse - show truncated text
            $fullText.hide();
            $truncatedText.show();
            $toggle.attr('aria-expanded', 'false');
            $toggleText.text('see more');
          }
        });
      } else {
        // Content is short enough, hide toggle and show full text
        $toggle.hide();
        $fullText.show();
        $truncatedText.hide();
      }
    });
  }
  
  // Initialize on page load
  initializeProductDescriptionToggle();
  
  // Re-initialize when product content changes (for dynamic content)
  $(document).on('shopify:section:load', function() {
    setTimeout(initializeProductDescriptionToggle, 100);
  });
});

// Function to toggle the cart bubble visibility
function toggleCartBubble(cartData) {
  const cartBubble = document.querySelector('.cart-link__bubble');
  if (cartData.items.length > 0) {
    cartBubble.classList.add('cart-link__bubble--visible'); // Show bubble if cart has items
    cartBubble.style.display = 'block'; // Ensure it's displayed
  } else {
    cartBubble.classList.remove('cart-link__bubble--visible'); // Hide bubble if cart is empty
    cartBubble.style.display = 'none'; // Ensure it's hidden
  }
}

// Function to dynamically inject the cart drawer
function injectCartDrawer() {
  const cartDrawerHTML = `
    <div id="CartDrawer" class="drawer drawer--right is-empty">
      <form id="CartDrawerForm" action="{{ routes.cart_url }}" method="post" novalidate class="drawer__contents" data-location="cart-drawer">
        <div class="drawer__fixed-header">
          <div class="drawer__header">
            <div class="h2 drawer__title">{{ 'cart.general.title' | t }}</div>
            <div class="drawer__close">
              <button type="button" class="drawer__close-button js-drawer-close">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>
                <span class="icon__fallback-text">{{ 'cart.general.close_cart' | t }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="drawer__inner">
          <div class="drawer__scrollable">
            <div class="cart__items"></div>
            <div class="cart__subtotal">
              <span>{{ 'cart.general.subtotal' | t }}</span>
              <span data-subtotal>0.00</span>
            </div>
            <div class="drawer__cart-empty" style="display: none;">
              <div>{{ 'cart.general.empty' | t }}</div>
            </div>
          </div>

          <div class="drawer__footer">
            <a href="{{ routes.cart_url }}" class="btn btn--full">{{ 'cart.general.view_cart' | t }}</a>
            <button type="submit" name="checkout" class="btn cart__checkout">{{ 'cart.general.checkout' | t }}</button>
          </div>
        </div>
      </form>
    </div>
  `;

  // Inject cart drawer HTML into the body
  const body = document.querySelector('body');
  body.insertAdjacentHTML('beforeend', cartDrawerHTML);

  return document.querySelector('#CartDrawer');
}

function formatMoney(amount) {
  // Custom money formatting (Shopify stores prices in cents, so divide by 100)
  const currencySymbol = "$"; // You can change this to your store's currency symbol
  const formattedAmount = (amount / 100).toFixed(2); // Format the amount with 2 decimal places
  return `${currencySymbol}${formattedAmount}`;
}

function updateCartDrawerContent(cartData) {
  console.log('[updateCartDrawerContent] Cart data received:', cartData);

  // Update the cart items in the drawer
  const cartItemsContainer = document.querySelector('.cart__items');
  const cartDrawer = document.querySelector('#CartDrawer');
  if (!cartItemsContainer) {
    console.error('[Error] Cart items container not found!');
    return; // Exit if the container doesn't exist
  }

  console.log('[Cart Items Container Found]');
  cartItemsContainer.innerHTML = ''; // Clear previous items

  // Update the subtotal
  const subtotalElement = document.querySelector('[data-subtotal]');
  if (subtotalElement) {
    let totalPrice = 0;
    cartData.items.forEach(item => {
      console.log('Item line_price:', item.line_price); // Log each item's line_price
      totalPrice += item.line_price;
    });

    console.log('Total Price:', totalPrice); // Log the total price for debugging
    subtotalElement.textContent = formatMoney(totalPrice); // Update the subtotal based on the total price
  }

  // If there are no items, show the empty cart message
  const emptyMessage = document.querySelector('.drawer__cart-empty');
  if (cartData.items.length === 0) {
    if (emptyMessage) {
      emptyMessage.style.display = 'block'; // Show empty cart message
    }
    // Ensure the drawer has the 'is-empty' class when the cart is empty
    cartDrawer.classList.add('is-empty');
    return; // Exit if cart is empty
  } else {
    if (emptyMessage) {
      emptyMessage.style.display = 'none'; // Hide empty cart message
    }
    // Remove the 'is-empty' class when the cart has items
    cartDrawer.classList.remove('is-empty');
  }

  // Loop through the cart items and update the drawer
  cartData.items.forEach(item => {
    console.log('[Rendering Item]', item); // Log each item being added

    // Extract necessary item details
    const productTitle = item.product_title || item.title || "Unknown Product";
    const productUrl = item.url || "#";
    const productImage = item.image || "default-image.jpg";
    const itemQuantity = item.quantity || 1;
    const itemPrice = item.line_price || item.price;
    
    // Infer product line from title or URL
    let productLine = '';
    if (productTitle.includes('City Builder') || productUrl.includes('city')) {
      productLine = 'City Builder';
    } else if (productTitle.includes('Dungeon') || productUrl.includes('dungeon')) {
      productLine = 'Dungeon';
    } else if (productTitle.includes('Cavern') || productUrl.includes('cavern')) {
      productLine = 'Cavern';
    } else if (productTitle.includes('Forest') || productUrl.includes('forest')) {
      productLine = 'Forest';
    } else if (productTitle.includes('Mountain') || productUrl.includes('mountain')) {
      productLine = 'Mountain';
    } else if (productTitle.includes('Swamp') || productUrl.includes('swamp')) {
      productLine = 'Swamp';
    } else {
      productLine = 'Other';
    }

    // Render each cart item
    const itemElement = document.createElement('div');
    itemElement.classList.add('cart__item');
    itemElement.innerHTML = `
      <div class="cart__item" data-key="${item.key}" data-product-line="${productLine}">
        <div class="cart__image">
          <a href="${productUrl}" class="image-wrap">
            <img src="${productImage}" alt="${productTitle}" />
          </a>
        </div>
        <div class="cart__item-details">
          <div class="cart__item-title">
            <a href="${productUrl}" class="cart__item-name">${productTitle}</a>
          </div>
          <div class="cart__item-sub">
            <div class="js-qty__wrapper">
              <label for="cart_updates_${item.key}" class="hidden-label">{{ 'cart.label.quantity' | t }}</label>
              <input type="number" id="cart_updates_${item.key}" name="updates[]" class="js-qty__num" value="${itemQuantity}" data-id="${item.key}" min="0" max="9" />
              <button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduce item quantity by one">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>
                <span class="icon__fallback-text" aria-hidden="true">−</span>
              </button>
              <button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase item quantity by one">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>
                <span class="icon__fallback-text" aria-hidden="true">+</span>
              </button>
            </div>
          </div>
          <div class="cart__item-price-col text-right">
            ${formatMoney(itemPrice)}  <!-- Use custom formatMoney function here -->
          </div>
        </div>
      </div>
    `;
    cartItemsContainer.appendChild(itemElement);

    // Add event listeners for the quantity input fields to handle real-time updates
    const qtyInput = itemElement.querySelector('.js-qty__num');
    const minusBtn = itemElement.querySelector('.js-qty__adjust--minus');
    const plusBtn = itemElement.querySelector('.js-qty__adjust--plus');

    if (qtyInput) {
      // Update on input change (manual change)
      qtyInput.addEventListener('change', function(e) {
        const quantity = parseInt(e.target.value, 10);
        const itemId = e.target.getAttribute('data-id');
        updateCartItemQuantity(itemId, quantity);
      });
    }

    if (minusBtn) {
      // Decrease quantity by 1 when minus button is clicked
      minusBtn.addEventListener('click', function() {
        const currentQuantity = parseInt(qtyInput.value, 10);
        if (currentQuantity > 0) {
          qtyInput.value = currentQuantity - 1;
          updateCartItemQuantity(item.key, qtyInput.value); // Update the cart item with new quantity
        }
      });
    }

    if (plusBtn) {
      // Increase quantity by 1 when plus button is clicked
      plusBtn.addEventListener('click', function() {
        const currentQuantity = parseInt(qtyInput.value, 10);
        if (currentQuantity < 9) {  // Make sure the quantity does not exceed max
          qtyInput.value = currentQuantity + 1;
          updateCartItemQuantity(item.key, qtyInput.value); // Update the cart item with new quantity
        }
      });
    }
  });

  // Ensure the drawer is visible (especially if it is hidden or in an animation state)
  setTimeout(() => {
    if (cartDrawer) {
      cartDrawer.style.display = 'block'; // Ensure the drawer is visible
      console.log('[Cart Drawer Refreshed]');
    }
  }, 100); // Small delay for DOM to update
}


// Function to update the quantity of an item via AJAX
function updateCartItemQuantity(itemId, quantity) {
  if (quantity === 0) {
    // If quantity is 0, remove the item
    removeCartItem(itemId);
  } else {
    // Otherwise, update the item quantity
    fetch(`/cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: itemId,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cartData => {
      console.log('[Cart Updated]', cartData);
      updateCartDrawerContent(cartData);  // Update the drawer with the new cart data
    })
    .catch(error => {
      console.error('[Error updating cart item quantity]', error);
    });
  }
}

// Function to remove an item from the cart via AJAX
function removeCartItem(itemId) {
  fetch(`/cart/change.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: itemId,
      quantity: 0
    })
  })
  .then(response => response.json())
  .then(cartData => {
    console.log('[Cart Item Removed]', cartData);
    updateCartDrawerContent(cartData);  // Update the drawer with the new cart data
  })
  .catch(error => {
    console.error('[Error removing cart item]', error);
  });
}

// Function to remove all out of stock items from cart
function removeOutOfStockItems() {
  // Prevent multiple simultaneous calls
  if (window.removingOutOfStockItems) {
    return;
  }
  window.removingOutOfStockItems = true;
  
  const noticeElement = document.querySelector('.cart__out-of-stock-notice');
  if (!noticeElement) {
    window.removingOutOfStockItems = false;
    return;
  }
  
  const outOfStockKeys = noticeElement.getAttribute('data-out-of-stock-keys');
  if (!outOfStockKeys || outOfStockKeys.trim() === '') {
    window.removingOutOfStockItems = false;
    return;
  }
  
  // Parse and validate keys
  const keys = outOfStockKeys.split(',').map(key => key.trim()).filter(key => key.length > 0);
  if (keys.length === 0) {
    window.removingOutOfStockItems = false;
    return;
  }
  
  // Disable the link/button to prevent multiple clicks
  const removeLink = document.querySelector('[data-remove-oos-items]');
  const originalText = removeLink ? removeLink.textContent : '';
  const isButton = removeLink && removeLink.classList.contains('cart__remove-oos-btn');
  
  if (removeLink) {
    removeLink.style.pointerEvents = 'none';
    removeLink.style.opacity = '0.6';
    removeLink.style.cursor = 'not-allowed';
    removeLink.setAttribute('disabled', 'disabled');
    
    // Update text based on whether it's a button or link
    if (isButton) {
      removeLink.textContent = 'REMOVING...';
    } else {
      removeLink.textContent = 'Removing...';
    }
  }
  
  // Track successful and failed removals
  let successCount = 0;
  let failCount = 0;
  const totalToRemove = keys.length;
  const errors = [];
  
  // Helper function to handle completion
  function handleCompletion() {
    const allComplete = (successCount + failCount) === totalToRemove;
    
    if (allComplete) {
      // Reset flag
      window.removingOutOfStockItems = false;
      
      // Check if we're on the cart page or in the drawer
      const isCartPage = document.querySelector('#CartPageForm') !== null;
      const isCartDrawer = document.querySelector('#CartDrawerForm') !== null;
      
      // Show error message if some removals failed
      if (failCount > 0 && errors.length > 0) {
        const errorMsg = failCount === totalToRemove 
          ? 'Unable to remove out of stock items. Please try again or remove them manually.'
          : `Some items could not be removed (${failCount} of ${totalToRemove}). The page will refresh.`;
        alert(errorMsg);
      }
      
      // Reload page to refresh cart
      if (isCartPage) {
        window.location.reload();
      } else if (isCartDrawer) {
        localStorage.setItem("Open Cart", "true");
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        window.location.reload();
      }
    }
  }
  
  // Remove items sequentially to avoid race conditions and API rate limits
  async function removeItemsSequentially() {
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      
      try {
        const response = await fetch(`/cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: 0
          })
        });
        
        const cartData = await response.json();
        
        // Check for Shopify API errors
        if (!response.ok || cartData.status === 422 || cartData.description) {
          throw new Error(cartData.description || cartData.message || 'Failed to remove item');
        }
        
        successCount++;
        
        // If cart becomes empty, break early
        if (cartData.item_count === 0) {
          break;
        }
      } catch (error) {
        failCount++;
        errors.push({ key: key, error: error.message });
      }
      
      // Small delay between requests to avoid rate limiting
      if (i < keys.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
    
    handleCompletion();
  }
  
  // Start removal process
  removeItemsSequentially().catch(error => {
    // Final error handler
    window.removingOutOfStockItems = false;
    if (removeLink) {
      removeLink.textContent = originalText;
      removeLink.style.pointerEvents = '';
      removeLink.style.opacity = '';
      removeLink.style.cursor = '';
      removeLink.removeAttribute('disabled');
    }
    alert('An error occurred while removing items. Please try again.');
  });
}

// Make function globally accessible
window.removeOutOfStockItems = removeOutOfStockItems;

// Initialize bulk remove functionality - use event delegation on document
// This works for dynamically loaded content (like cart drawer and cart page)
// Set up immediately (not waiting for DOMContentLoaded) to catch all clicks
(function() {
  document.addEventListener('click', function(e) {
    // Check if the clicked element or its parent has the data attribute
    const removeLink = e.target.closest('[data-remove-oos-items]');
    if (removeLink && !removeLink.hasAttribute('disabled') && !window.removingOutOfStockItems) {
      e.preventDefault();
      e.stopPropagation();
      
      // Make sure function is accessible
      if (typeof window.removeOutOfStockItems === 'function') {
        window.removeOutOfStockItems();
      }
    }
  }, true); // Use capture phase to catch events early
})();

// Function to update active state for product swatches
function updateVariantSwatchActiveState(productSection) {
  if (!productSection) return;
  
  // Get all variant swatch labels in this product section
  const variantSwatches = productSection.querySelectorAll('.variant__button-label--product-swatch');
  
  if (variantSwatches.length === 0) return;
  
  // Remove active class from all swatches in this section
  variantSwatches.forEach(function(swatch) {
    swatch.classList.remove('variant__button-label--active');
  });
  
  // Find all checked inputs in this product section
  const checkedInputs = productSection.querySelectorAll('input[data-variant-input]:checked');
  
  checkedInputs.forEach(function(checkedInput) {
    const label = productSection.querySelector(`label[for="${checkedInput.id}"]`);
    if (label && label.classList.contains('variant__button-label--product-swatch')) {
      label.classList.add('variant__button-label--active');
    }
  });
}

// Update active state for product swatches when variant changes
document.addEventListener('variant:change', function(event) {
  const detail = event.detail;
  if (!detail) return;
  
  // Find all product sections on the page
  const productSections = document.querySelectorAll('.product-section');
  
  productSections.forEach(function(productSection) {
    updateVariantSwatchActiveState(productSection);
  });
});

// Listen for clicks on variant swatch labels - ensure input gets checked immediately
$(document).on('click', '.variant__button-label--product-swatch', function(e) {
  const $label = $(this);
  const productSection = $label.closest('.product-section');
  if (productSection.length === 0) return;
  
  // Get the associated input
  const inputId = $label.attr('for');
  if (!inputId) return;
  
  const $input = productSection.find(`#${inputId}`);
  if ($input.length === 0) return;
  
  // Get the option index to uncheck other inputs in the same group
  const optionIndex = $input.data('index');
  if (optionIndex) {
    // Uncheck all other inputs in the same option group first
    productSection.find(`input[data-variant-input][data-index="${optionIndex}"]`).prop('checked', false);
  }
  
  // Check this input immediately - CSS will handle the visual state
  $input.prop('checked', true);
  
  // Trigger change event to ensure theme updates
  $input.trigger('change');
});

// Listen for the actual input change/click to sync state and remove old active classes
$(document).on('change', 'input[data-variant-input]', function() {
  const $input = $(this);
  const productSection = $input.closest('.product-section');
  if (productSection.length === 0) return;
  
  // Remove active class from all swatches (CSS :checked will handle the visual state)
  productSection.find('.variant__button-label--product-swatch').removeClass('variant__button-label--active');
  
  // Add active class to checked inputs for fallback/JavaScript compatibility
  productSection.find('input[data-variant-input]:checked').each(function() {
    const label = productSection.find(`label[for="${this.id}"]`);
    if (label.hasClass('variant__button-label--product-swatch')) {
      label.addClass('variant__button-label--active');
    }
  });
});

// Also listen for direct input changes as a fallback
$(document).on('change', 'input[data-variant-input]', function() {
  const productSection = $(this).closest('.product-section');
  if (productSection.length === 0) return;
  
  updateVariantSwatchActiveState(productSection[0]);
});

// Function to render variant swatches for a product element
function renderVariantSwatchesForProduct($productElement) {
  // Skip if already processed
  if ($productElement.data('variant-swatches-processed')) {
    return;
  }
  
  const productId = $productElement.data('product-id');
  const productHandle = $productElement.data('product-handle');
  
  if (!productId && !productHandle) return;
  
  // Check if product has product-swatches tag by looking for it in the DOM or making an AJAX call
  // First, try to get product data from Shopify's product API
  if (!productHandle) {
    $productElement.data('variant-swatches-processed', true);
    return;
  }
  
  const productUrl = '/products/' + productHandle;
  if (!productUrl || productUrl === '/products/') {
    $productElement.data('variant-swatches-processed', true);
    return;
  }
  
  // Check if we can find product tags in existing data attributes or make AJAX call
  $.ajax({
    url: productUrl + '.js',
    type: 'GET',
    dataType: 'json',
    success: function(product) {
      // Check if product has product-swatches tag
      const hasProductSwatchesTag = product.tags && product.tags.indexOf('product-swatches') !== -1;
      
      if (!hasProductSwatchesTag) {
        $productElement.data('variant-swatches-processed', true);
        return;
      }
      
      // Count variants with images
      let variantSwatchesTotal = 0;
      const variantsWithImages = [];
      
      if (product.variants) {
        product.variants.forEach(function(variant) {
          if (variant.featured_image || variant.image) {
            variantSwatchesTotal++;
            variantsWithImages.push(variant);
          }
        });
      }
      
      if (variantSwatchesTotal === 0) {
        $productElement.data('variant-swatches-processed', true);
        return;
      }
      
      // Find the price element
      const $priceElement = $productElement.find('.grid-product__price').last();
      if ($priceElement.length === 0) {
        $productElement.data('variant-swatches-processed', true);
        return;
      }
      
      // Check if variant swatches already exist
      if ($productElement.find('.grid-product__variant-swatches').length > 0) {
        $productElement.data('variant-swatches-processed', true);
        return;
      }
      
      // Create variant swatches HTML
      let swatchesHTML = '<div class="grid-product__variant-swatches grid-product__variant-swatches--' + productId + '" data-product-id="' + productId + '">';
      
      const maxSwatches = Math.min(5, variantsWithImages.length);
      for (let i = 0; i < maxSwatches; i++) {
        const variant = variantsWithImages[i];
        let variantImage = variant.featured_image || variant.image;
        
        // Handle different image formats from Shopify API
        let imageUrl = '';
        if (typeof variantImage === 'string') {
          imageUrl = variantImage;
        } else if (variantImage && variantImage.src) {
          imageUrl = variantImage.src;
        }
        
        if (!imageUrl) continue;
        
        // Convert to proper Shopify image URLs
        // Replace extension (with dot) with size suffix + extension
        const imageUrl60 = imageUrl.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_60x60$1');
        const imageUrl400 = imageUrl.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_400x400$1');
        
        const soldOutClass = !variant.available ? ' grid-product__variant-swatch--sold-out' : '';
        const soldOutLine = !variant.available ? '<span class="grid-product__variant-swatch-sold-out-line"></span>' : '';
        
        swatchesHTML += '<a href="' + productUrl + '?variant=' + variant.id + '" ' +
          'class="grid-product__variant-swatch' + soldOutClass + '" ' +
          'data-variant-id="' + variant.id + '" ' +
          'data-variant-image="' + imageUrl400 + '" ' +
          'data-product-image="' + (product.featured_image ? (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src) : '') + '" ' +
          'aria-label="' + product.title + ' - ' + variant.title + '">' +
          '<span class="grid-product__variant-swatch-skeleton"></span>' +
          '<img src="' + imageUrl60 + '" alt="' + variant.title + '" class="grid-product__variant-swatch-image" loading="lazy">' +
          soldOutLine +
          '<span class="visually-hidden">' + variant.title + '</span>' +
          '</a>';
      }
      
      if (variantSwatchesTotal > 5) {
        const remainingCount = variantSwatchesTotal - 5;
        swatchesHTML += '<span class="grid-product__variant-swatch grid-product__variant-swatch--count">' + remainingCount + '+</span>';
      }
      
      swatchesHTML += '</div>';
      
      // Insert after the price element's parent (grid-product__meta) or after the link
      const $linkElement = $productElement.find('.grid-product__link');
      if ($linkElement.length > 0) {
        $linkElement.after(swatchesHTML);
      } else {
        $priceElement.parent().after(swatchesHTML);
      }
      
      // Add data attributes to image wrapper if not already present
      const $imageWrapper = $productElement.find('.grid__item-image-wrapper');
      if ($imageWrapper.length > 0 && !$imageWrapper.data('product-image-wrapper')) {
        let featuredImage = '';
        if (product.featured_image) {
          featuredImage = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image.src || '');
        }
        // Convert to 400x400 size for hover functionality
        if (featuredImage) {
          featuredImage = featuredImage.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_400x400$1');
        }
        $imageWrapper.attr('data-product-image-wrapper', productId);
        $imageWrapper.attr('data-featured-image', featuredImage);
      }
      
      // Preload all variant images for snappy hover
      const $swatchesContainer = $productElement.find('.grid-product__variant-swatches');
      preloadVariantImages($swatchesContainer, variantsWithImages);
      
      // Initialize image load handlers and hover functionality
      initializeVariantSwatchImages($productElement.find('.grid-product__variant-swatch-image'));
      initializeVariantSwatchHover($productElement.find('.grid-product__variant-swatch'));
      
      $productElement.data('variant-swatches-processed', true);
    },
    error: function() {
      $productElement.data('variant-swatches-processed', true);
    }
  });
}

// Function to preload all variant images for snappy hover
function preloadVariantImages($swatchesContainer, variants) {
  if (!variants || variants.length === 0) return;
  
  variants.forEach(function(variant) {
    let variantImage = variant.featured_image || variant.image;
    if (!variantImage) return;
    
    // Handle different image formats from Shopify API
    let imageUrl = '';
    if (typeof variantImage === 'string') {
      imageUrl = variantImage;
    } else if (variantImage && variantImage.src) {
      imageUrl = variantImage.src;
    }
    
    if (!imageUrl) return;
    
    // Preload both thumbnail (60x60) and hover (400x400) sizes
    const imageUrl60 = imageUrl.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_60x60$1');
    const imageUrl400 = imageUrl.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_400x400$1');
    
    // Create image objects to preload
    const img60 = new Image();
    const img400 = new Image();
    
    img60.src = imageUrl60;
    img400.src = imageUrl400;
  });
}

// Function to initialize image load handlers for variant swatch images
function initializeVariantSwatchImages($images) {
  $images.each(function() {
    const $img = $(this);
    const $swatch = $img.closest('.grid-product__variant-swatch');
    const $skeleton = $swatch.find('.grid-product__variant-swatch-skeleton');
    
    // Check if image is already loaded
    if (this.complete && this.naturalHeight !== 0) {
      $img.addClass('loaded');
      $skeleton.hide();
      return;
    }
    
    // Handle successful load
    $img.on('load', function() {
      $(this).addClass('loaded');
      $skeleton.hide();
    });
    
    // Handle error (fallback to show image anyway after a delay)
    $img.on('error', function() {
      // Still show the image even if there was an error
      setTimeout(function() {
        $img.addClass('loaded');
        $skeleton.hide();
      }, 500);
    });
  });
}

// Function to initialize hover functionality for variant swatches
function initializeVariantSwatchHover($swatches) {
  $swatches.each(function() {
    const $swatch = $(this);
    const $productElement = $swatch.closest('.grid-product');
    const $imageWrapper = $productElement.find('[data-product-image-wrapper]');
    const $productContent = $productElement.find('.grid-product__content');
    
    if ($imageWrapper.length === 0) return;
    
    // Store original image sources if not already stored (do this once per product)
    if (!$imageWrapper.data('original-images-stored')) {
      const $firstImage = $imageWrapper.find('.grid__image-ratio img');
      const $imageWrap = $imageWrapper.find('.image-wrap img');
      const $secondImage = $imageWrapper.find('.grid-product__secondary-image');
      
      if ($firstImage.length > 0) {
        $imageWrapper.data('original-first-src', $firstImage.attr('src'));
        $imageWrapper.data('original-first-srcset', $firstImage.attr('srcset'));
      }
      if ($imageWrap.length > 0) {
        $imageWrapper.data('original-wrap-src', $imageWrap.attr('src'));
        $imageWrapper.data('original-wrap-srcset', $imageWrap.attr('srcset'));
      }
      if ($secondImage.length > 0) {
        $imageWrapper.data('has-secondary-image', true);
      }
      $imageWrapper.data('original-images-stored', true);
    }
    
    // Remove existing handlers to avoid duplicates
    $swatch.off('mouseenter mouseleave');
    
    // Add hover handlers with event propagation control
    $swatch.on('mouseenter', function(e) {
      e.stopPropagation(); // Prevent card hover from triggering
      
      const variantImage = $(this).data('variant-image');
      if (!variantImage) return;
      
      const $firstImage = $imageWrapper.find('.grid__image-ratio img');
      const $secondImage = $imageWrapper.find('.grid-product__secondary-image');
      const $imageWrap = $imageWrapper.find('.image-wrap img');
      
      // Hide secondary image when hovering over swatches
      if ($secondImage.length > 0) {
        $secondImage.css('opacity', '0');
        $productContent.addClass('variant-swatch-hovering');
      }
      
      // Replace main image with variant image
      if ($firstImage.length > 0) {
        $firstImage.attr('src', variantImage);
        $firstImage.attr('srcset', variantImage);
      } else if ($imageWrap.length > 0) {
        $imageWrap.attr('src', variantImage);
        $imageWrap.attr('srcset', variantImage);
      }
    });
    
    $swatch.on('mouseleave', function(e) {
      e.stopPropagation(); // Prevent card hover from triggering
      
      const $firstImage = $imageWrapper.find('.grid__image-ratio img');
      const $secondImage = $imageWrapper.find('.grid-product__secondary-image');
      const $imageWrap = $imageWrapper.find('.image-wrap img');
      
      // Check if we're still hovering over any swatch in this product
      const $swatchesContainer = $productElement.find('.grid-product__variant-swatches');
      const isHoveringSwatches = $swatchesContainer.is(':hover') || $swatchesContainer.find(':hover').length > 0;
      
      if (!isHoveringSwatches) {
        // Restore original image
        const originalFirstSrc = $imageWrapper.data('original-first-src');
        const originalFirstSrcset = $imageWrapper.data('original-first-srcset');
        const originalWrapSrc = $imageWrapper.data('original-wrap-src');
        const originalWrapSrcset = $imageWrapper.data('original-wrap-srcset');
        
        if ($firstImage.length > 0 && originalFirstSrc) {
          $firstImage.attr('src', originalFirstSrc);
          $firstImage.attr('srcset', originalFirstSrcset || originalFirstSrc);
        } else if ($imageWrap.length > 0 && originalWrapSrc) {
          $imageWrap.attr('src', originalWrapSrc);
          $imageWrap.attr('srcset', originalWrapSrcset || originalWrapSrc);
        }
        
        // Restore secondary image visibility
        if ($secondImage.length > 0) {
          $secondImage.css('opacity', '');
          $productContent.removeClass('variant-swatch-hovering');
        }
      }
    });
  });
}

// Function to check if a product should be moved to the end based on tags
function shouldMoveProductToEnd($product) {
  const productId = $product.data('product-id');
  const productHandle = $product.data('product-handle');
  const productTitle = $product.find('.grid-product__link, .grid-product__meta').first().text().trim() || 'Unknown';
  
  console.log('[MoveCheck] Checking product:', productTitle, '(ID:', productId, ', Handle:', productHandle, ')');
  
  // Check if already processed
  if ($product.data('move-check-processed')) {
    const shouldMove = $product.data('should-move') === true;
    console.log('[MoveCheck] Already processed, should move:', shouldMove);
    return shouldMove;
  }
  
  // First, try to get tags from hidden div in the product HTML
  const $hiddenTagsDiv = $product.find('div[style*="display: none"]');
  if ($hiddenTagsDiv.length > 0) {
    const tagsText = $hiddenTagsDiv.text().trim();
    console.log('[MoveCheck] Found hidden tags div, tags:', tagsText.substring(0, 100));
    if (tagsText && tagsText.includes('hide_from_collection_grid')) {
      $product.data('move-check-processed', true);
      $product.data('should-move', true);
      console.log('[MoveCheck] ✓ Product should be moved to end (found tag in hidden div)');
      return true;
    }
    // If tags div exists but doesn't contain the tag, mark as processed
    $product.data('move-check-processed', true);
    $product.data('should-move', false);
    console.log('[MoveCheck] ✗ Product should NOT be moved (no tag found)');
    return false;
  }
  
  // If no hidden tags div, fetch product data via AJAX
  if (!productHandle && !productId) {
    // Can't check, mark as processed to avoid infinite loops
    $product.data('move-check-processed', true);
    $product.data('should-move', false);
    console.log('[MoveCheck] ✗ Cannot check (no handle or ID), assuming keep');
    return false;
  }
  
  // Fetch product data to check tags
  const productUrl = productHandle ? '/products/' + productHandle + '.js' : null;
  
  if (productUrl) {
    // Check if already processing to prevent duplicate requests
    if ($product.data('move-check-processing')) {
      console.log('[MoveCheck] Already processing AJAX check, waiting...');
      return false; // Already processing, wait for callback
    }
    
    // Mark as processing to prevent duplicate requests
    $product.data('move-check-processing', true);
    console.log('[MoveCheck] Starting AJAX check for:', productUrl);
    
    $.ajax({
      url: productUrl,
      type: 'GET',
      dataType: 'json',
      success: function(product) {
        const hasHideTag = product.tags && product.tags.indexOf('hide_from_collection_grid') !== -1;
        $product.data('move-check-processed', true);
        $product.data('should-move', hasHideTag);
        $product.data('move-check-processing', false);
        
        console.log('[MoveCheck] AJAX result for', product.title, '- hasHideTag:', hasHideTag, '- tags:', product.tags);
        
        if (hasHideTag && $product.length > 0 && $product.parent().length > 0) {
          // Move the product to the end of the container
          console.log('[MoveCheck] ✓ Moving product to end via AJAX check:', product.title);
          moveProductToEnd($product);
        } else {
          console.log('[MoveCheck] ✗ Keeping product in place (no hide tag found)');
        }
      },
      error: function(xhr, status, error) {
        // On error, don't move the product
        $product.data('move-check-processed', true);
        $product.data('should-move', false);
        $product.data('move-check-processing', false);
        console.error('[MoveCheck] ✗ AJAX error for', productUrl, '- Status:', status, '- Error:', error);
      }
    });
    
    // Return false for now, will be updated by AJAX callback
    return false;
  }
  
  console.log('[MoveCheck] ✗ No product URL available, assuming keep');
  return false;
}

// Function to move a single product to the end of the products container
// Note: This is used for individual products detected via MutationObserver
function moveProductToEnd($product) {
  const $productsContainer = $('.products-on-page');
  if ($productsContainer.length === 0) {
    console.log('[MoveToEnd] No products container found');
    return;
  }
  
  // Check if already marked as moved
  if ($product.data('moved-to-end')) {
    console.log('[MoveToEnd] Product already moved to end, skipping');
    return;
  }
  
  // Check if product is already at the end
  const $allProducts = $productsContainer.find('.grid-product');
  const currentIndex = $allProducts.index($product);
  const lastIndex = $allProducts.length - 1;
  
  if (currentIndex === lastIndex) {
    console.log('[MoveToEnd] Product already at end position, marking as moved');
    $product.data('moved-to-end', true);
    return;
  }
  
  // Detach and append to end
  $product.detach();
  $product.data('moved-to-end', true);
  $productsContainer.append($product);
  console.log('[MoveToEnd] Moved product to end of container');
}

// Function to move products with hide_from_collection_grid tag to the end
function moveHiddenProductsToEnd() {
  console.log('[Filter] Starting moveHiddenProductsToEnd()');
  const $productsContainer = $('.products-on-page');
  if ($productsContainer.length === 0) {
    console.log('[Filter] No products container found');
    return 0;
  }
  
  const totalProducts = $productsContainer.find('.grid-product').length;
  console.log('[Filter] Total products to check:', totalProducts);
  
  if (totalProducts === 0) {
    console.log('[Filter] No products found');
    return 0;
  }
  
  let movedCount = 0;
  let checkedCount = 0;
  const productsToMove = [];
  
  // First pass: identify products that should be moved
  $productsContainer.find('.grid-product').each(function() {
    checkedCount++;
    const $product = $(this);
    
    // Skip if already marked as moved to end
    if ($product.data('moved-to-end')) {
      return;
    }
    
    const productTitle = $product.find('.grid-product__link, .grid-product__meta').first().text().trim() || 'Unknown';
    
    if (shouldMoveProductToEnd($product)) {
      productsToMove.push($product);
      movedCount++;
      console.log('[Filter] Marked product for moving:', productTitle);
    }
  });
  
  // Second pass: move all identified products to the end at once
  if (productsToMove.length > 0) {
    console.log('[Filter] Moving', productsToMove.length, 'products to end');
    
    // Detach all products to move
    productsToMove.forEach(function($product) {
      $product.detach();
      $product.data('moved-to-end', true);
    });
    
    // Append them all to the end
    productsToMove.forEach(function($product) {
      $productsContainer.append($product);
    });
    
    console.log('[Filter] Successfully moved', productsToMove.length, 'products to end');
  }
  
  console.log('[Filter] Filter complete - Checked:', checkedCount, ', Moved to end:', movedCount);
  return movedCount;
}

// Function to calculate expected products per page
function getExpectedProductsPerPage() {
  // Try to get from section settings or calculate from grid
  const $productsContainer = $('.products-on-page');
  if ($productsContainer.length === 0) return 0;
  
  // Check if we can determine per_row from existing products
  const $firstProduct = $productsContainer.find('.grid-product').first();
  if ($firstProduct.length === 0) {
    // If no products yet, try to get from URL or check initial page load
    // For cloud search, we might need to wait for initial products
    return 0;
  }
  
  // Get per_row from grid classes (e.g., medium-up--one-quarter = 4 per row)
  let perRow = 4; // default
  const gridClasses = $firstProduct.attr('class') || '';
  if (gridClasses.includes('medium-up--one-half')) perRow = 2;
  else if (gridClasses.includes('medium-up--one-third')) perRow = 3;
  else if (gridClasses.includes('medium-up--one-quarter')) perRow = 4;
  else if (gridClasses.includes('medium-up--one-fifth')) perRow = 5;
  else if (gridClasses.includes('medium-up--one-sixth')) perRow = 6;
  
  // Try to get rows_per_page from data attribute or default to 7
  // Also check if we can infer from initial product count
  let rowsPerPage = parseInt($productsContainer.data('rows-per-page')) || 7;
  
  // If we have products, try to infer rows_per_page from initial count
  // But only if we haven't filtered yet (to get the original expected count)
  const initialCount = $productsContainer.find('.grid-product').length;
  
  // Store the initial expected count if not already stored
  if (!$productsContainer.data('initial-expected-count') && initialCount > 0) {
    // Try to calculate: if we have 28 products and 4 per row, that's 7 rows
    const calculatedRows = Math.ceil(initialCount / perRow);
    if (calculatedRows >= 3 && calculatedRows <= 20) {
      rowsPerPage = calculatedRows;
      const expected = perRow * rowsPerPage;
      $productsContainer.data('initial-expected-count', expected);
      console.log('[FillGaps] Stored initial expected count:', expected, 'based on', initialCount, 'products');
      return expected;
    }
  }
  
  // Use stored expected count if available
  const storedExpected = $productsContainer.data('initial-expected-count');
  if (storedExpected) {
    console.log('[FillGaps] Using stored expected count:', storedExpected);
    return storedExpected;
  }
  
  const expected = perRow * rowsPerPage;
  console.log('[FillGaps] Calculated expected products per page:', expected, '(perRow:', perRow, ', rowsPerPage:', rowsPerPage, ')');
  return expected;
}

// Track if we're currently filling gaps to prevent infinite loops
let isFillingGaps = false;

// Function to load more products to fill gaps after filtering
function fillProductGaps() {
  // Prevent multiple simultaneous gap-filling operations
  if (isFillingGaps) {
    console.log('[FillGaps] Already filling gaps, skipping');
    return;
  }
  
  const $productsContainer = $('.products-on-page');
  if ($productsContainer.length === 0) {
    console.log('[FillGaps] No products container found');
    return;
  }
  
  // Make sure next_url is up to date
  if (!next_url || next_url === undefined) {
    next_url = $('.pagination .next a').attr('href');
  }
  
  const expectedCount = getExpectedProductsPerPage();
  if (expectedCount === 0) {
    console.log('[FillGaps] Cannot determine expected count');
    return; // Can't determine expected count
  }
  
  const currentCount = $productsContainer.find('.grid-product').length;
  console.log('[FillGaps] Current count:', currentCount, 'Expected:', expectedCount, 'Next URL:', next_url);
  
  // If we have enough products or no next page, stop
  if (currentCount >= expectedCount) {
    console.log('[FillGaps] Already have enough products');
    return;
  }
  
  if (!next_url) {
    console.log('[FillGaps] No next page URL available');
    return;
  }
  
  const neededCount = expectedCount - currentCount;
  console.log('[FillGaps] Need', neededCount, 'more products, loading next page...');
  isFillingGaps = true;
  
  // Load next page to fill gaps
  $.ajax({
    url: next_url,
    type: "GET",
    dataType: "html",
    success: function(next_page) {
      const $nextPage = $(next_page);
      const $newProducts = $nextPage.find('.products-on-page .grid-product');
      const newNextUrl = $nextPage.find('.pagination .next a').attr('href');
      
      // Update next_url
      next_url = newNextUrl;
      
      // Add all new products to container, we'll filter them after
      const $productsContainer = $('.products-on-page');
      const productsToAdd = [];
      
      $newProducts.each(function() {
        const $product = $(this).clone();
        productsToAdd.push($product);
      });
      
      console.log('[FillGaps] Found', $newProducts.length, 'products on next page');
      
      // Add all products first
      let addedCount = 0;
      productsToAdd.forEach(function($product) {
        const productTitle = $product.find('.grid-product__link, .grid-product__meta').first().text().trim() || 'Unknown';
        $productsContainer.append($product);
        addedCount++;
        console.log('[FillGaps] Added product', addedCount, ':', productTitle);
      });
      
      console.log('[FillGaps] Added', addedCount, 'products, now filtering...');
      
      // Now move products with hide tag to the end
      const movedAfterAdd = moveHiddenProductsToEnd();
      console.log('[FillGaps] Moved', movedAfterAdd, 'products to end after adding new ones');
      
      // Update load more button visibility
      if (!next_url) {
        loadMoreBtn.hide();
        $('.browse-by-page').hide();
      } else {
        loadMoreBtn.show();
      }
      
      isFillingGaps = false;
      
      // If we still need more products and there's a next page, continue
      setTimeout(function() {
        const newCurrentCount = $productsContainer.find('.grid-product').length;
        console.log('[FillGaps] After filtering, current count:', newCurrentCount, 'Expected:', expectedCount);
        if (newCurrentCount < expectedCount && next_url) {
          console.log('[FillGaps] Still need more products, continuing...');
          fillProductGaps();
        } else {
          console.log('[FillGaps] Done filling gaps');
        }
      }, 1000); // Increased delay to allow async filtering to complete
      
      // Initialize variant swatches for new products
      $productsContainer.find('.grid-product').not('[data-variant-swatches-processed]').each(function() {
        const $product = $(this);
        setTimeout(function() {
          renderVariantSwatchesForProduct($product);
        }, 100);
      });
    },
    error: function() {
      console.error('Error loading more products to fill gaps');
      isFillingGaps = false;
    }
  });
}

// MutationObserver to watch for Cloud Search products being added dynamically
if (typeof MutationObserver !== 'undefined') {
  const variantSwatchesObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          const $node = $(node);
          
          // Check if it's a product element or contains product elements
          let $products = $node.hasClass('grid-product') ? $node : $node.find('.grid-product');
          
          if ($products.length === 0 && $node.closest('.products-on-page').length > 0) {
            // Check if the added node is within products-on-page
            $products = $node.closest('.products-on-page').find('.grid-product').not('[data-variant-swatches-processed]');
          }
          
          console.log('[MutationObserver] Detected', $products.length, 'new product(s) added to DOM');
          
          let removedInBatch = false;
          $products.each(function(index) {
            const $product = $(this);
            const productTitle = $product.find('.grid-product__link, .grid-product__meta').first().text().trim() || 'Unknown';
            console.log('[MutationObserver] Processing product', index + 1, ':', productTitle);
            
            // Check if product should be moved to end
            if (shouldMoveProductToEnd($product)) {
              // Move the product to the end of the container
              console.log('[MutationObserver] Moving product to end:', productTitle);
              moveProductToEnd($product);
              removedInBatch = true;
              return; // Skip variant swatch processing for moved products (will process after move)
            }
            
            if (!$product.data('variant-swatches-processed')) {
              // Small delay to ensure product data is available
              setTimeout(function() {
                renderVariantSwatchesForProduct($product);
              }, 100);
            }
          });
          
          // If products were moved, log it
          if (removedInBatch) {
            console.log('[MutationObserver] Products were moved to end in this batch');
          } else {
            console.log('[MutationObserver] No products moved in this batch');
          }
        }
      });
    });
  });
  
  // Start observing when DOM is ready
  $(document).ready(function() {
    const $productsContainer = $('.products-on-page');
    if ($productsContainer.length > 0) {
      variantSwatchesObserver.observe($productsContainer[0], {
        childList: true,
        subtree: true
      });
      
      console.log('[DOMReady] Setting up MutationObserver and initial filtering');
      
      // Update next_url if not set
      if (!next_url) {
        next_url = $('.pagination .next a').attr('href');
        console.log('[DOMReady] Initial next_url:', next_url);
      }
      
      const initialProductCount = $productsContainer.find('.grid-product').length;
      console.log('[DOMReady] Initial product count:', initialProductCount);
      
      // Move products with hide tag to the end
      const movedCount = moveHiddenProductsToEnd();
      console.log('[DOMReady] Initial filter moved', movedCount, 'products to end');
      
      // Also process existing products for variant swatches
      $productsContainer.find('.grid-product').each(function() {
        const $product = $(this);
        if (!$product.data('variant-swatches-processed')) {
          setTimeout(function() {
            renderVariantSwatchesForProduct($product);
          }, 500);
        }
      });
    }
  });
}

// Handle tooltip positioning for product swatches to prevent off-screen tooltips
function positionProductSwatchTooltip(tooltip, swatch) {
  if (!tooltip || !swatch) return;
  
  // Remove wrap class to start fresh
  tooltip.classList.remove('tooltip-wrap');
  
  // Reset to default first to get accurate measurements
  tooltip.style.left = '50%';
  tooltip.style.transform = 'translateX(-50%)';
  tooltip.style.setProperty('--tooltip-arrow-left', '50%');
  tooltip.style.maxWidth = '';
  
  // Force reflow to get accurate measurements
  void tooltip.offsetWidth;
  
  const tooltipRect = tooltip.getBoundingClientRect();
  const swatchRect = swatch.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const padding = 10; // Padding from screen edge
  
  let left = '50%';
  let transform = 'translateX(-50%)';
  let needsWrap = false;
  let isLeftSide = false;
  
  // Check if tooltip goes off left edge
  if (tooltipRect.left < padding) {
    isLeftSide = true;
    const offset = padding - tooltipRect.left;
    left = '0';
    transform = `translateX(${offset}px)`;
    // Check if we can fit by wrapping instead
    const availableWidth = swatchRect.left - padding;
    if (availableWidth < tooltipRect.width) {
      needsWrap = true;
    }
  }
  
  // Check if tooltip goes off right edge
  if (tooltipRect.right > viewportWidth - padding) {
    const offset = (viewportWidth - padding) - tooltipRect.right;
    left = '100%';
    transform = `translateX(calc(-100% + ${-offset}px))`;
    // Check if we can fit by wrapping instead
    const availableWidth = viewportWidth - swatchRect.right - padding;
    if (availableWidth < tooltipRect.width) {
      needsWrap = true;
    }
  }
  
  // If tooltip would go off screen even after positioning, allow wrapping
  if (needsWrap || tooltipRect.width > (viewportWidth - padding * 2)) {
    tooltip.classList.add('tooltip-wrap');
    // Reset positioning before measuring wrapped size
    tooltip.style.left = '50%';
    tooltip.style.transform = 'translateX(-50%)';
    // Recalculate after wrap
    void tooltip.offsetWidth;
    const wrappedRect = tooltip.getBoundingClientRect();
    
    // Reposition based on wrapped dimensions
    if (wrappedRect.left < padding || isLeftSide) {
      // For left side, align tooltip left edge with padding
      // Calculate: swatch left edge + offset to reach padding
      const swatchLeft = swatchRect.left;
      const offset = padding - swatchLeft;
      left = '0';
      transform = `translateX(${offset}px)`;
    } else if (wrappedRect.right > viewportWidth - padding) {
      const swatchRight = swatchRect.right;
      const offset = (viewportWidth - padding) - swatchRight;
      left = '100%';
      transform = `translateX(calc(-100% + ${-offset}px))`;
    } else {
      // Can stay centered
      left = '50%';
      transform = 'translateX(-50%)';
    }
  }
  
  // Apply positioning
  tooltip.style.left = left;
  tooltip.style.transform = transform;
  
  // Force reflow to get new position
  void tooltip.offsetWidth;
  
  // Final check and adjustment for left-side wrapped tooltips
  const finalTooltipRect = tooltip.getBoundingClientRect();
  if (finalTooltipRect.left < padding) {
    const swatchLeft = swatchRect.left;
    const offset = padding - swatchLeft;
    tooltip.style.left = '0';
    tooltip.style.transform = `translateX(${offset}px)`;
    // Force reflow again
    void tooltip.offsetWidth;
  }
  
  // Now calculate arrow position based on final tooltip position
  const adjustedRect = tooltip.getBoundingClientRect();
  const swatchCenterX = swatchRect.left + swatchRect.width / 2;
  const tooltipLeftX = adjustedRect.left;
  const arrowOffset = swatchCenterX - tooltipLeftX;
  
  tooltip.style.setProperty('--tooltip-arrow-left', `${arrowOffset}px`);
}

// Handle tooltip positioning on hover
$(document).on('mouseenter', '.variant__button-label--product-swatch', function() {
  const $swatch = $(this);
  const $tooltip = $swatch.find('.variant-swatch-tooltip');
  
  if ($tooltip.length) {
    // First make tooltip visible (CSS will handle this, but we ensure it)
    $tooltip.css({
      'visibility': 'visible',
      'opacity': '1'
    });
    
    // Use requestAnimationFrame to ensure DOM has updated before calculating position
    requestAnimationFrame(function() {
      // Calculate and apply positioning
      positionProductSwatchTooltip($tooltip[0], $swatch[0]);
    });
  }
});

$(document).on('mouseleave', '.variant__button-label--product-swatch', function() {
  const $tooltip = $(this).find('.variant-swatch-tooltip');
  // Reset positioning for next hover
  $tooltip.css({
    'visibility': 'hidden',
    'opacity': '0',
    'left': '',
    'transform': '',
    'maxWidth': ''
  });
  $tooltip.removeClass('tooltip-wrap');
  if ($tooltip[0]) {
    $tooltip[0].style.removeProperty('--tooltip-arrow-left');
  }
});

// Also handle window resize to reposition tooltips
let resizeTimeout;
$(window).on('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function() {
    $('.variant__button-label--product-swatch:hover .variant-swatch-tooltip').each(function() {
      const $tooltip = $(this);
      const $swatch = $tooltip.closest('.variant__button-label--product-swatch');
      if ($swatch.length) {
        positionProductSwatchTooltip($tooltip[0], $swatch[0]);
      }
    });
  }, 100);
});

});

// Product Modal Functionality
(function() {
  'use strict';
  
  let productsCache = null;
  let productsCachePromise = null;
  let initializedModals = new Set();
  let escKeyHandler = null;
  let activeModal = null;
  let previousActiveElement = null;

  // Function to fetch all products with pagination (cached)
  function fetchProducts() {
    if (productsCache) {
      return Promise.resolve(productsCache);
    }
    if (productsCachePromise) {
      return productsCachePromise;
    }
    
    // Fetch all pages of products
    async function fetchAllPages() {
      let allProducts = [];
      let page = 1;
      const limit = 250; // Max allowed by Shopify
      
      while (true) {
        try {
          const response = await fetch('/products.json?limit=' + limit + '&page=' + page);
          if (!response.ok) {
            throw new Error('Failed to fetch products: ' + response.status);
          }
          const data = await response.json();
          
          if (!data || !Array.isArray(data.products) || data.products.length === 0) {
            break;
          }
          
          allProducts = allProducts.concat(data.products);
          
          // If we got fewer products than the limit, we've reached the end
          if (data.products.length < limit) {
            break;
          }
          
          page++;
          
          // Safety limit to prevent infinite loops
          if (page > 50) {
            console.warn('Reached maximum page limit for product fetch');
            break;
          }
        } catch (error) {
          console.warn('Error fetching products page ' + page + ':', error);
          break;
        }
      }
      
      return allProducts;
    }
    
    productsCachePromise = fetchAllPages()
      .then(products => {
        productsCache = products;
        return productsCache;
      })
      .catch(error => {
        console.warn('Could not fetch products:', error);
        productsCachePromise = null;
        return [];
      });
    
    return productsCachePromise;
  }

  // Global ESC key handler (only one listener for all modals)
  function handleEscKey(e) {
    if (e.key === 'Escape' && activeModal) {
      closeModal(activeModal);
    }
  }

  // Focus trap management
  function trapFocus(modal) {
    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    function handleTabKey(e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }

    modal.addEventListener('keydown', handleTabKey);
    return function cleanup() {
      modal.removeEventListener('keydown', handleTabKey);
    };
  }

  function openModal(modal) {
    if (!modal) return;
    
    // Store previous active element for focus restoration
    previousActiveElement = document.activeElement;
    
    // Set as active modal
    activeModal = modal;
    
    // Update modal state
    modal.classList.add('set-piece-modal--active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Focus first focusable element
    const firstFocusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      firstFocusable.focus();
    }
    
    // Setup ESC key handler if not already set
    if (!escKeyHandler) {
      escKeyHandler = handleEscKey;
      document.addEventListener('keydown', escKeyHandler);
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    
    // Update modal state
    modal.classList.remove('set-piece-modal--active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    
    // Clear active modal
    activeModal = null;
    
    // Restore focus to previous element
    if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
      previousActiveElement.focus();
    }
    previousActiveElement = null;
  }

  function initProductModals() {
    const modals = document.querySelectorAll('.set-piece-modal:not([data-initialized]), .shirt-sizing-modal:not([data-initialized])');
    
    if (modals.length === 0) {
      return;
    }
    
    modals.forEach(function(modal) {
      const modalId = modal.id;
      if (!modalId || initializedModals.has(modalId)) {
        return;
      }
      
      const setPieceMatch = modalId.match(/SetPieceModal-(.+)-(\d+)/);
      const shirtSizingMatch = modalId.match(/ShirtSizingModal-(.+)-(\d+)/);
      const match = setPieceMatch || shirtSizingMatch;

      if (!match) {
        return;
      }
      
      // Mark as initialized
      modal.setAttribute('data-initialized', 'true');
      initializedModals.add(modalId);
      
      const key = match[1] + '-' + match[2];
      const isSetPieceModal = Boolean(setPieceMatch);
      const modalData = isSetPieceModal && window.setPieceModalData && window.setPieceModalData[key];
      const openButtonClass = isSetPieceModal ? '.js-modal-open-set-piece-' : '.js-modal-open-shirt-sizing-';
      
      // Find open buttons for this modal
      const openButtons = document.querySelectorAll(openButtonClass + key);
      const closeButtons = modal.querySelectorAll('.js-modal-close');
      const overlay = modal.querySelector('.set-piece-modal__overlay, .shirt-sizing-modal__overlay');
      
      // Setup focus trap
      trapFocus(modal);
      
      // Function to handle opening modal
      function handleOpenModal() {
        openModal(modal);
        
        // Load product data if needed
        if (isSetPieceModal && modalData && modalData.isPiece && modalData.productIds && modalData.productIds.length > 0) {
          loadProductData(modal, modalData.productIds);
        }
      }
      
      // Attach listeners to existing buttons
      openButtons.forEach(btn => {
        if (!btn.hasAttribute('data-modal-listener-attached')) {
          btn.setAttribute('data-modal-listener-attached', 'true');
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            handleOpenModal();
          });
        }
      });
      
      // If no buttons found, try again after a short delay (for dynamically loaded content)
      if (openButtons.length === 0) {
        setTimeout(function() {
          const retryButtons = document.querySelectorAll(openButtonClass + key + ':not([data-modal-listener-attached])');
          retryButtons.forEach(btn => {
            btn.setAttribute('data-modal-listener-attached', 'true');
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              handleOpenModal();
            });
          });
        }, 500);
      }
      
      // Close modal on close button click
      closeButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeModal(modal);
        });
      });
      
      // Close modal on overlay click
      if (overlay) {
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) {
            closeModal(modal);
          }
        });
      }
      
      // Prevent modal content clicks from closing modal
      const modalContent = modal.querySelector('.set-piece-modal__content, .shirt-sizing-modal__content');
      if (modalContent) {
        modalContent.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }
    });
  }
  
  function loadProductData(modal, productIds) {
    if (!Array.isArray(productIds) || productIds.length === 0) {
      return;
    }
    
    fetchProducts().then(products => {
      if (!Array.isArray(products) || products.length === 0) {
        console.warn('Set Piece Modal: No products fetched from /products.json');
        return;
      }
      
      productIds.forEach(function(productId) {
        // Use loose equality to handle string/number type mismatches
        const numericId = Number(productId);
        const product = products.find(p => Number(p.id) === numericId);
        const itemElements = modal.querySelectorAll('[data-product-id="' + productId + '"]');
        
        // Debug logging
        if (!product) {
          console.warn('Set Piece Modal: Product not found in /products.json for ID:', productId, '- Total products fetched:', products.length);
        }
        
        if (!itemElements || itemElements.length === 0) {
          console.warn('Set Piece Modal: No DOM elements found for product ID:', productId);
          return;
        }
        
        itemElements.forEach(function(itemElement) {
          // Update product name (works for both grid and table views)
          const nameElement = itemElement.querySelector('[data-product-name="' + productId + '"]');
          if (nameElement) {
            if (product && product.title) {
              nameElement.textContent = product.title;
            } else {
              // Show SKU from the element's sibling or a generic name
              const skuElement = itemElement.querySelector('.set-piece-modal__item-sku, .set-piece-modal__table-code');
              const skuText = skuElement ? skuElement.textContent.replace('SKU: ', '').trim() : '';
              nameElement.textContent = skuText || 'View in Database';
            }
          }
          
          // Update product image in grid view
          const imagePlaceholder = itemElement.querySelector('.set-piece-modal__item-image .set-piece-modal__item-image-placeholder');
          if (imagePlaceholder && product && product.images && Array.isArray(product.images) && product.images.length > 0) {
            const imageUrl = product.images[0];
            if (imageUrl) {
              const img = document.createElement('img');
              img.src = imageUrl;
              img.alt = product.title || 'Product image';
              img.loading = 'eager';
              img.onerror = function() {
                // If image fails to load, show placeholder
                this.style.display = 'none';
                const placeholder = imagePlaceholder.parentElement.querySelector('.set-piece-modal__item-image-placeholder');
                if (placeholder) {
                  placeholder.style.display = 'block';
                }
              };
              img.onload = function() {
                // Image loaded successfully - hide placeholder if it exists
                const placeholder = imagePlaceholder.parentElement.querySelector('.set-piece-modal__item-image-placeholder');
                if (placeholder && placeholder !== this) {
                  placeholder.style.display = 'none';
                }
              };
              // Replace placeholder with image
              imagePlaceholder.parentElement.replaceChild(img, imagePlaceholder);
              // Add a backup placeholder that's hidden
              const backupPlaceholder = document.createElement('div');
              backupPlaceholder.className = 'set-piece-modal__item-image-placeholder';
              backupPlaceholder.style.display = 'none';
              img.parentElement.appendChild(backupPlaceholder);
            }
          }
          
          // Update product image in table view
          const tableImagePlaceholder = itemElement.querySelector('.set-piece-modal__table-image .set-piece-modal__item-image-placeholder');
          if (tableImagePlaceholder && product && product.images && Array.isArray(product.images) && product.images.length > 0) {
            const imageUrl = product.images[0];
            if (imageUrl) {
              const img = document.createElement('img');
              img.src = imageUrl;
              img.alt = product.title || 'Product image';
              img.loading = 'eager';
              img.onerror = function() {
                // If image fails to load, show placeholder
                this.style.display = 'none';
                const placeholder = tableImagePlaceholder.parentElement.querySelector('.set-piece-modal__item-image-placeholder');
                if (placeholder) {
                  placeholder.style.display = 'block';
                }
              };
              img.onload = function() {
                // Image loaded successfully - hide placeholder if it exists
                const placeholder = tableImagePlaceholder.parentElement.querySelector('.set-piece-modal__item-image-placeholder');
                if (placeholder && placeholder !== this) {
                  placeholder.style.display = 'none';
                }
              };
              // Replace placeholder with image
              tableImagePlaceholder.parentElement.replaceChild(img, tableImagePlaceholder);
              // Add a backup placeholder that's hidden
              const backupPlaceholder = document.createElement('div');
              backupPlaceholder.className = 'set-piece-modal__item-image-placeholder';
              backupPlaceholder.style.display = 'none';
              img.parentElement.appendChild(backupPlaceholder);
            }
          }
        });
      });
    }).catch(function(error) {
      console.warn('Error loading product data:', error);
    });
  }
  
  // Initialize when DOM is ready
  function initialize() {
    initProductModals();
  }
  
  // Initialize immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  // Also initialize after delays to catch dynamically loaded content
  setTimeout(initialize, 500);
  setTimeout(initialize, 1500);
  
  // Also listen for DOM mutations to catch dynamically added modals/buttons
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.classList && (
                node.classList.contains('set-piece-modal') ||
                node.classList.contains('shirt-sizing-modal') ||
                node.matches('[class*="js-modal-open-set-piece-"]') ||
                node.matches('[class*="js-modal-open-shirt-sizing-"]')
              )) {
                shouldReinit = true;
              }
              if (node.querySelector && (
                node.querySelector('.set-piece-modal') ||
                node.querySelector('.shirt-sizing-modal') ||
                node.querySelector('[class*="js-modal-open-set-piece-"]') ||
                node.querySelector('[class*="js-modal-open-shirt-sizing-"]')
              )) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      if (shouldReinit) {
        setTimeout(initialize, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();